import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { IRemoteUpdateClassWrapper, ILifescapeUpdateClassWrapper, ILifescapeCourseClassWrapper, IDownloadSoftwareResponse } from './software.service.model';

@Injectable({
  providedIn: 'root'
})
export class SoftwareService {

  rootScopeData: RootScopeDeclare;

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService, private httpHeaderService: HttpHeadersService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  public getRemoteSoftwareUpdates(facilityId: string, consoleType: string): Observable<IRemoteUpdateClassWrapper> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const postData: any = {};
    postData.facilityIds = facilityId;
    postData.consoleType = consoleType;
    const result = this.httpClient.post(environment.servicePath + '/software_update/get_remote_software', postData, { headers });
    return result as Observable<IRemoteUpdateClassWrapper>;
  }

  public saveRemoteSoftwareUpdates(facilityId: string[], consoleType: string, autoUpdateFlag: boolean): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const postData: any = {};
    postData.facilityIdList = facilityId;
    postData.consoleType = consoleType;
    postData.isUpdate = autoUpdateFlag.toString();
    return this.httpClient.post(environment.servicePath + '/software_update/save_remote_software', postData, { headers });
  }

  public publishRemoteSoftwareUpdates(assetIds: string[], latestSoftwareVersion: string, scheduleFlag: boolean): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const postData: any = {};
    postData.assetIds = assetIds;
    postData.latestSoftwareVersion = latestSoftwareVersion;
    postData.isSchedule = false;
    return this.httpClient.post(environment.servicePath + '/software_update/publish_remote_software', postData, { headers });
  }

  public getLifescapeCoursesUpdates(facilityIds: string[], consoleType: string): Observable<ILifescapeUpdateClassWrapper> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let params = new HttpParams();
    if (facilityIds.length > 1) {
      for (const facilityId of facilityIds) {
        params = params.append('fIds', facilityId);
      }
    } else {
      params = params.append('fIds', facilityIds[0]);
    }
    params =  params.append('consoleType', consoleType);
    const result = this.httpClient.get(environment.servicePath + '/lifescape_course/get_lifescape_course_update', { params: params,headers });
    return result as Observable<ILifescapeUpdateClassWrapper>;
  }
  public getLifescapeDownloadLinks(): Observable<ILifescapeCourseClassWrapper> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this.httpClient.get(environment.servicePath + '/lifescape_course/get_lifescape_link', { headers });
    return result as Observable<ILifescapeCourseClassWrapper>;
  }

  public saveLifescapeCoursesUpdates(facilityId: string[], consoleType: string, isUpdateFlag: boolean): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const postData: any = {};
    postData.facilityIdList = facilityId;
    postData.consoleType = consoleType;
    postData.isUpdate = isUpdateFlag.toString();
    return this.httpClient.post(environment.servicePath + '/lifescape_course/save_lifescape_course_update', postData, { headers });
  }

  public getDownloadSoftware(facilityId: string, userId: string): Observable<IDownloadSoftwareResponse> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let params = new HttpParams();
        params = params.append('facilityId', facilityId);
      params =  params.append('userId', userId);
    const result = this.httpClient.get(environment.servicePath + '/software_update/get_download_software', { params: params,headers });
    return result as Observable<IDownloadSoftwareResponse>;
  }
  

  getSoftwareVersion(version: string) {
    if (version != null) {
      if (version.length == 5) {
        version = "0" + version;
      }
      return `${version.substr(0, 2)}.${version.substr(2, 2)}.${version.substr(4)}`;
    }
    else {
      return "";
    }
  }
}
